import { Route } from '@/app/router'

const ShipmentClaims = () => import('./index.vue')

const CommonProps = ['page', 'perPage']

export default new Route('/shipment-claims', ShipmentClaims)
	.as('Dashboard:ShipmentClaims')
	.props(CommonProps)
